import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "InvoiceSummary" }
const _hoisted_2 = { class: "InvoiceRow InvoiceHeader" }
const _hoisted_3 = { class: "ValueCell" }
const _hoisted_4 = {
  key: 0,
  class: "InvoiceRow"
}
const _hoisted_5 = { class: "ValueCell" }
const _hoisted_6 = {
  key: 1,
  class: "InvoiceRow"
}
const _hoisted_7 = { class: "ValueCell" }
const _hoisted_8 = {
  key: 2,
  class: "InvoiceRow"
}
const _hoisted_9 = { class: "ValueCell" }
const _hoisted_10 = {
  key: 3,
  class: "InvoiceRow"
}
const _hoisted_11 = { class: "ValueCell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Organisation:", -1 /* CACHED */)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.organisationName) + " (ID: " + _toDisplayString(_ctx.organisationIdentity) + ") ", 1 /* TEXT */)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "InvoiceRow ColumnHeader" }, [
      _createElementVNode("span", null, "Success fee category"),
      _createElementVNode("span", { class: "ValueCell" }, "Number")
    ], -1 /* CACHED */)),
    (_ctx.getNumberOfRegularSuccessFee() > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Regular-qualified", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getNumberOfRegularSuccessFee()), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.getNumberOfReducedBecauseAgentInvolvedSuccessFee() > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Reduced (agent involved)", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getNumberOfReducedBecauseAgentInvolvedSuccessFee()), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.getNumberOfReducedBecauseNationalitySuccessFee() > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Reduced (country)", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getNumberOfReducedBecauseNationalitySuccessFee()), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.getNumberOfOtherSuccessFee() > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Other", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getNumberOfOtherSuccessFee()), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}